'use client';
import {
    TrmzFileConcernContext,
    useProvideTrmzFile
} from "@web-libs/features/files/trmz-file/application/use-trmz-file.concern";

export function TrmzFileProvider({children}: { children: any }) {
    const trmzFileConcern = useProvideTrmzFile()
    return (
            <TrmzFileConcernContext.Provider value={trmzFileConcern}>
                {children}
            </TrmzFileConcernContext.Provider>
    )
}
